module.exports = __webpack_public_path__ + "static/media/sz.1e261ba0.svg";